/* eslint-disable react/forbid-component-props */
import { Box, Grid, SxProps, Theme } from '@mui/material';
import { Ribbon } from '@/data/types/Product';
import { combineSX } from '@/utils/combineSX';

export const generateRibbonClass = (ribbon: Ribbon) => {
	const cleanValueRibbon = `ribbon-${ribbon.value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}`;
	const cleanTypeRibbon = `ribbon-${ribbon.identifier.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}`;

	if (cleanTypeRibbon === cleanValueRibbon) {
		return `ribbon ${cleanTypeRibbon}`;
	}

	return `ribbon ${cleanTypeRibbon} ${cleanValueRibbon}`;
};

const ribbonSX: SxProps<Theme> = {
	p: '2px 6px',
	color: 'white',
	fontSize: 'var(--font-size-small)',
	backgroundColor: '#ff5524',
	textDecoration: 'none',
	textTransform: 'uppercase',
	fontWeight: 'bold',
	borderRadius: '11px',
	width: 'auto',
	textAlign: 'center',
};

export const ProductRibbons = ({ ribbons: [first, ...rest] }: { ribbons: Ribbon[] }) => (
	<Grid
		sx={{
			position: 'absolute',
			top: '8px',
			left: '4px',
		}}
	>
		{first?.value ? (
			<Box
				className={generateRibbonClass(first)}
				sx={combineSX([
					ribbonSX,
					{
						mb: '4px',
					},
				])}
			>
				{`${first.value}`}
			</Box>
		) : null}

		{rest.map((ribbon) => (
			<Box key={ribbon.value} className={generateRibbonClass(ribbon)} sx={ribbonSX}>
				{`${ribbon.value}`}
			</Box>
		))}
	</Grid>
);
